import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";

import SlideShow from "../../components/slider";
import GradientHero from "../../components/gradientHero";

import HorizontalIcons from "../../components/horizontal-icons";
import Layout from "../../components/layout";

const Commercial = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "commercial", idType: URI) {
          commercialPage {
            ciHeader
            ciIcons {
              header
              image {
                altText
                sourceUrl
              }
            }
            ciLink {
              target
              title
              url
            }
            csHeader
            csItems {
              content
              header
              link {
                target
                title
                url
              }
              image {
                altText
                sourceUrl
              }
            }
            mainText
            heroSlides {
              content
              header
              toggle
              image {
                altText
                sourceUrl
              }
              link {
                target
                title
                url
              }
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.commercialPage || {};

  return (
    <Layout pageContext={pageContext}>
      <SlideShow>
        {data?.heroSlides
          ?.filter((v) => v?.toggle)
          ?.map((v, i) => (
            <React.Fragment key={i}>
              <GradientHero image={v?.image?.sourceUrl}>
                <h5>{v?.header}</h5>

                <p dangerouslySetInnerHTML={{ __html: v?.content }}></p>
                <a target={v?.link?.target} href={v?.link?.url}>
                  {v?.link?.title}
                </a>
              </GradientHero>
            </React.Fragment>
          ))}
      </SlideShow>

      <div className="bg-black py-20">
        <h3 className="text-center text-5xl mb-10">{data?.csHeader}</h3>
        <div className="flex flex-wrap mx-auto w-full md:w-4/5 lg:w-3/4 xl:w-11/12 2xl:w-4/5 overflow-hidden text-white max-w-7xl fom-section">
          {data?.csItems?.map((v, i) => (
            <div
              key={i}
              className="my-4 px-4 w-1/2 overflow-hidden w-full md:w-1/2 lg:w-1/2 xl:w-1/4"
            >
              <div className="w-full flex-col h-full flex flex-col">
                <div className="h-32 flex flex-center">
                  <img className="mx-auto" src={v?.image?.sourceUrl} />
                </div>
                <h5 className="text-center text-3xl mt-2 mb-5 h-20">
                  {v?.header}
                </h5>
                <p className="mb-3">{v?.content}</p>

                <a
                  href={v?.link?.url}
                  target={v?.link?.target}
                  className="mt-auto"
                >
                  <div className="bg-tan text-lg text-black uppercase font-anton text-center w-full py-2">
                    {v?.link?.title}
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-5xl  my-20 mx-5 md:mx-20 lg:mx-auto">
        <p dangerouslySetInnerHTML={{ __html: data?.mainText }}></p>
      </div>

      <div style={{ backgroundColor: "#F8F8F8" }}>
        <HorizontalIcons
          icons={data?.ciIcons?.map((v) => ({
            text: v?.header,
            image: v?.image?.sourceUrl,
          }))}
        />

        <div className="max-w-7xl text-center mx-auto pt-3 pb-32">
          <h3 className="text-black text-center text-3xl mb-10">
            {data?.ciHeader}
          </h3>
          <a
            className="mt-30 bg-tan text-2xl text-black uppercase font-anton px-16 py-3"
            href={data?.ciLink?.url}
            target={data?.ciLink?.target}
          >
            {data?.ciLink?.title}
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default Commercial;
